/* eslint-disable @typescript-eslint/no-unused-expressions */
/* tslint:disable */
const regex = {
  uppercase: '[A-Z]',
  special: '[^A-Za-z0-9]',
  numbers: '[0-9]',
  lowercase: '[a-z]',
};

const defaults = {
  total: 0,
  uppercase: 0,
  lowercase: 0,
  specials: 0,
  numbers: 0,
};

export const checkStringComplexity = (str: string = ''): typeof defaults => {
  const chars = str.split('');

  const res = Object.assign({}, defaults);
  res.total = chars.length;

  let char = chars.pop();
  while (char) {
    RegExp(regex.lowercase).test(char) && res.lowercase++;
    RegExp(regex.uppercase).test(char) && res.uppercase++;
    RegExp(regex.numbers).test(char) && res.numbers++;
    RegExp(regex.special).test(char) && res.specials++;
    char = chars.pop();
  }

  return res;
};
